const qs = require('qs')
const { showError } = require('../libs/helper')

module.exports = {
  getBmdDetail: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API}sensus-pengguna/get-detail`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  validasi: async (g, data) => {
    await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/store-validasi-sensus`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(() => {
        g.$router.push({ name: 'validasiKeberadaan' })
      })
      .catch(err => {
        showError(g, err, 'Error Submit Form')
      })
  },
}
